// Firestore transport fix (2026-08-09) — WKWebView on iOS standalone (PWA,
// added-to-homescreen) is the one environment where WebChannel streaming is
// known-broken (see firebase/config.js). Detection split into a pure
// predicate (testable without mocking window/navigator/matchMedia) and a
// thin environment reader that's the actual call site.

// iPadOS ships a desktop Safari UA by default ("Macintosh; ..."), so the
// iPad/iPhone/iPod UA regex alone misses it. maxTouchPoints > 1 is what
// actually distinguishes a touch iPad in desktop-UA mode from a real Mac.
export function isIosStandalone({ standalone, displayModeStandalone, userAgent, maxTouchPoints }) {
  const isIosLikeUA =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (/Macintosh/.test(userAgent) && maxTouchPoints > 1);

  return standalone === true || (displayModeStandalone === true && isIosLikeUA);
}

export function detectIosStandalone() {
  const nav = typeof navigator !== 'undefined' ? navigator : {};
  const displayModeStandalone =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(display-mode: standalone)').matches
      : false;

  return isIosStandalone({
    standalone: nav.standalone,
    displayModeStandalone,
    userAgent: nav.userAgent || '',
    maxTouchPoints: nav.maxTouchPoints || 0,
  });
}
